import { render, staticRenderFns } from "./DialogEditTipoUso.vue?vue&type=template&id=ce865320"
import script from "./DialogEditTipoUso.vue?vue&type=script&lang=js"
export * from "./DialogEditTipoUso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports